import React from 'react';

const MarqueeServices = () => {
  // 21 brand names - exact list
  const brands = [
    'ebebek',
    'Molfix',
    'Tecno Mobile',
    'Braun',
    'Philips',
    'Pastel',
    'Prozinc',
    'ROCS',
    'Shevec',
    'Pınar Online',
    'Macro Center',
    'Dermotek',
    'Arabian Oud',
    'İnce Hesap',
    'Deko Pratik',
    'Oksizinc',
    'Chacha',
    'Direct',
    'Evdemo',
    'Greenwich',
    'Novakid'
  ];

  // Single brand item with middle dot separator
  const BrandItem = ({ brand, isFirst }) => (
    <div className="flex items-center flex-shrink-0">
      {!isFirst && (
        <span 
          className="mx-3 md:mx-5 text-sm md:text-base"
          style={{ color: 'rgba(0,0,0,0.3)' }}
        >
          ·
        </span>
      )}
      <span 
        className="text-sm md:text-base font-bold whitespace-nowrap"
        style={{ color: 'rgba(0,0,0,0.7)', letterSpacing: '1px' }}
      >
        {brand}
      </span>
    </div>
  );

  return (
    <div className="bg-[#FFDD59] overflow-hidden border-t-2 border-b-2 border-black/20">
      {/* Marquee - Right to Left */}
      <div className="py-3 md:py-4 overflow-hidden">
        <div 
          className="flex items-center"
          style={{
            animation: 'scroll 30s linear infinite',
            width: 'max-content'
          }}
        >
          {/* First set of brands */}
          {brands.map((brand, i) => <BrandItem key={`a-${i}`} brand={brand} isFirst={i === 0} />)}
          <span className="mx-3 md:mx-5 text-sm md:text-base" style={{ color: 'rgba(0,0,0,0.3)' }}>·</span>
          {/* Second set for seamless loop */}
          {brands.map((brand, i) => <BrandItem key={`b-${i}`} brand={brand} isFirst={i === 0} />)}
          <span className="mx-3 md:mx-5 text-sm md:text-base" style={{ color: 'rgba(0,0,0,0.3)' }}>·</span>
        </div>
      </div>

      {/* Mobile second row - reverse direction */}
      <div className="py-3 md:hidden border-t border-black/10 overflow-hidden">
        <div 
          className="flex items-center"
          style={{
            animation: 'scroll-reverse 30s linear infinite',
            width: 'max-content'
          }}
        >
          {brands.map((brand, i) => <BrandItem key={`c-${i}`} brand={brand} isFirst={i === 0} />)}
          <span className="mx-3 md:mx-5 text-sm md:text-base" style={{ color: 'rgba(0,0,0,0.3)' }}>·</span>
          {brands.map((brand, i) => <BrandItem key={`d-${i}`} brand={brand} isFirst={i === 0} />)}
          <span className="mx-3 md:mx-5 text-sm md:text-base" style={{ color: 'rgba(0,0,0,0.3)' }}>·</span>
        </div>
      </div>

      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes scroll-reverse {
          0% { transform: translateX(-50%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};

export default MarqueeServices;
